import { render, staticRenderFns } from "./CannotUsePurchaseVoucher.vue?vue&type=template&id=09a453c2&name=cannot-use-purchase-voucher&"
import script from "./CannotUsePurchaseVoucher.vue?vue&type=script&lang=js&"
export * from "./CannotUsePurchaseVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CannotUsePurchaseVoucher.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports